import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { config } from "../../../config/config";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';




const Contactus = () => {
  const [isContactFormActive, setIsContactFormActive] = useState(true);
  const [messageSent, setMessageSent] = useState(false);
  const [errorInSending, setErrorInSending] = useState(false);
  const schema = yup
    .object({
      name: yup.string().required("Name is required"),
      email: yup
        .string()
        .email("This must be a valid email")
        .required("Email is required"),
      phone: yup
        .string()
        .required("Mobile number is required")
        .matches(/^[0-9]+$/, "Mobile number must be a valid number")
        .min(10, "Mobile number must be exactly 10 digits")
        .max(10, "Mobile number must be exactly 10 digits"),
      message: yup
        .string()
        .required("Message is required")
        .min(8, "The message is minimum eight characters"),
    })
    .required();

  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    setErrorInSending(false);
    setIsContactFormActive(false);
    // perform async request, for example, using fetch
    const response = await fetch(config.env.mvitVantageEmailService, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      setIsContactFormActive(true);
      // // // check if response is successful
      if (response.ok) {
        setMessageSent(true);
      } else {
        setMessageSent(false);
        setErrorInSending(true);
      }
    }).then((data) => {
      //for now no use response data
    })
      .catch(error => {
        setMessageSent(false);
        setErrorInSending(true);
        setIsContactFormActive(true);
        // handle network errors or other exceptions
        console.error('An error occurred:', error.message);
      });
  };



  return (
    <>
      {/*==========================
    Contact Section
  ============================*/}
      <section id="contact">
        <div className="container-fluid">
          <div className="section-header">
            <h3>Contact Us</h3>
          </div>

          <div className="row wow fadeInUp">
            <div className="col-lg-6">
              <div className="map mb-4 mb-lg-0">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3680.530282626876!2d75.8079515!3d22.7085234!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fdb914ec654f%3A0xeb26c46eda23cade!2sMicrovision%20Infotech!5e0!3m2!1sen!2sin!4v1716143672147!5m2!1sen!2sin"
                  frameborder="0"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                  style={{ border: "0", width: "100%", height: "312px" }}
                ></iframe>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-4 info">
                  <i className="ion-ios-location-outline"></i>
                  <p>88, Sector I, Green Park Colony, Indore</p>
                </div>
                <div className="col-md-4 info">
                  <i className="ion-ios-email-outline"></i>
                  <p>
                    <a href="mailto:contact@microvisioninfotech.com">contact@microvisioninfotech.com</a>
                  </p>
                </div>
                <div className="col-md-4 info">
                  <i className="ion-ios-telephone-outline"></i>
                  <p style={{ whiteSpace: "nowrap", lineHeight: "1.5" }}>
                    <a href="tel:+918319203408">+91 831-920-3408</a><br />
                    <a href="tel:+919479716489">+91 94797-16489</a><br />
                    <a href="tel:+919827582762">+91 98275-82762</a>
                  </p>
                </div>
              </div>

              <div className="form">
                {messageSent ? (
                  <div>Your message has been sent. Thank you!</div>
                ) : (
                  ""
                )}
                {errorInSending ? <div>Error in form submission</div> : ""}

                <form
                  action=""
                  method="post"
                  role="form"
                  className={`contactForm ${isContactFormActive ? "" : "d-none"
                    }`}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <input
                    type="hidden"
                    name="to"
                    value={config.env.contactTo}
                    {...register("to")}
                  />
                  <input
                    type="hidden"
                    name="template"
                    value="contact_us"
                    {...register("template")}
                  />
                  <input
                    type="hidden"
                    name="email_requester"
                    value={config.env.currentDomain}
                    {...register("email_requester")}
                  />
                  <div className="form-row">
                    <div className="form-group col-lg-6">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        placeholder="Your Name"
                        data-rule="minlen:4"
                        data-msg="Please enter at least 4 chars"
                        {...register("name")}
                      />
                      {errors.name && <span>{errors.name.message}</span>}
                    </div>
                    <div className="form-group col-lg-6">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        placeholder="Your Email"
                        data-rule="email"
                        data-msg="Please enter a valid email"
                        {...register("email")}
                      />
                      {errors.email && <span>{errors.email.message}</span>}
                    </div>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      id="phone"
                      placeholder="Mobile Number"
                      {...register("phone")}
                    />
                    {errors.phone && <span>{errors.phone.message}</span>}
                  </div>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      name="message"
                      rows="5"
                      data-rule="required"
                      data-msg="Please write something for us"
                      placeholder="Message"
                      {...register("message")}
                    ></textarea>
                    {errors.message && <span>{errors.message.message}</span>}
                  </div>
                  <div className="text-center">
                    <button type="submit" title="Send Message">
                      Send Message
                    </button>
                  </div>
                </form>
                <img
                  id="processing"
                  className={`contactForm ${isContactFormActive ? "d-none" : ""
                    }`}
                  src="img/processing.gif"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* #contact */}
    </>
  );
};

export default Contactus;